import { ReactNode } from '@tanstack/react-router';
import { useFormContext } from 'react-hook-form';
import { FormRadioGroupField } from '@mews/framework';
import { RadioButton } from '@optimus-web/core';
import { AmountPart } from '@mews-commander/data-access';
import { ServicesProductFormValues } from '../types';
import { PriceAdjustmentDiscriminator } from '../schemas';
import { adjustmentOptions } from './constants';

interface Props {
    label: ReactNode;
    name: string;
}
export const AdjustmentTypeRadioGroupField = (props: Props) => {
    const { setValue, watch } = useFormContext<ServicesProductFormValues>();
    return (
        <FormRadioGroupField
            {...props}
            onChange={(e, value) => {
                switch (value as PriceAdjustmentDiscriminator) {
                    case PriceAdjustmentDiscriminator.Fixed:
                        if (watch('priceAdjustment.fixedValue.value') === undefined) {
                            // @ts-expect-error react-hook-form doesn't infer types inside discriminated unions correctly
                            setValue('priceAdjustment.fixedValue.value', 0);
                        }
                        break;
                    case PriceAdjustmentDiscriminator.Percentage:
                        if (watch('priceAdjustment.percentageValue.multiplier') === undefined) {
                            // @ts-expect-error react-hook-form doesn't infer types inside discriminated unions correctly
                            setValue('priceAdjustment.percentageValue.multiplier', 0);
                        }
                        if (watch('priceAdjustment.percentageValue.amountPart') === undefined) {
                            // @ts-expect-error react-hook-form doesn't infer types inside discriminated unions correctly
                            setValue('priceAdjustment.percentageValue.amountPart', AmountPart.GrossValue);
                        }
                        break;
                    case PriceAdjustmentDiscriminator.None:
                        break;
                }
            }}
        >
            {adjustmentOptions.map((option) => (
                <RadioButton key={option.value} value={option.value} label={option.label} />
            ))}
        </FormRadioGroupField>
    );
};
